import { render, staticRenderFns } from "./OfferView1.vue?vue&type=template&id=81617a3a&scoped=true"
import script from "./OfferView1.vue?vue&type=script&lang=js"
export * from "./OfferView1.vue?vue&type=script&lang=js"
import style0 from "./OfferView1.vue?vue&type=style&index=0&id=81617a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81617a3a",
  null
  
)

export default component.exports